import contextReducer from '../reducers/ContextReducer';
import redirectReducer from '../reducers/RedirectReducer';
// Cache integration
import cacheReducer from '../reducers/CacheReducer';
import solrCacheReducer from '../reducers/SOLRCacheReducer';

export const bootReducers = {
    context: contextReducer,
    cache: cacheReducer,
    redirectData: redirectReducer,
    solrCache: solrCacheReducer,
};

const reducerFactory = (initialReducers, asyncReducers = {}) => ({
    ...bootReducers,
    ...initialReducers,
    ...asyncReducers,
});

export default reducerFactory;
